/**
 * Build-time feature flags.
 *
 * Kept separate from `config.ts` (which throws on missing required vars) so flags can be read anywhere,
 * including module-level defaults and tests, without pulling in auth/backend config.
 */

/** System code for ModernPM in `ClientOnboardingForm.systems`. */
export const MPM_SYSTEM = 'MPM';

/**
 * ModernPM client creation. Enabled only when `VITE_ENABLE_MPM` is exactly `'true'`;
 * unset or any other value means OFF (the production default while ModernPM's firewall blocks our API calls).
 * Read at call time (not cached) so tests can toggle it with `vi.stubEnv`.
 */
export const isMpmEnabled = (): boolean => import.meta.env.VITE_ENABLE_MPM === 'true';

/** Drops ModernPM from a systems list when MPM creation is disabled. */
export const filterEnabledSystems = (systems: string[] | null | undefined): string[] => {
    const list = systems ?? [];
    return isMpmEnabled() ? list : list.filter((s) => s !== MPM_SYSTEM);
};

/** True when the given systems include ModernPM AND ModernPM creation is enabled. */
export const includesMpm = (systems: string[] | null | undefined): boolean =>
    filterEnabledSystems(systems).includes(MPM_SYSTEM);
